"use client";

import { c as _c } from "react/compiler-runtime";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "react-tooltip";
import UserCICTypeIconTooltip from "./tooltip/UserCICTypeIconTooltip";
import UserCICTypeIcon from "./UserCICTypeIcon";
export default function UserCICTypeIconWrapper(t0) {
  const $ = _c(14);
  const {
    profile
  } = t0;
  const tooltipId = `user-cic-type-tooltip-${profile.id}`;
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== profile.cic) {
    t3 = <UserCICTypeIcon cic={profile.cic} />;
    $[2] = profile.cic;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3 || $[5] !== tooltipId) {
    t4 = <div data-tooltip-id={tooltipId} className="tw-cursor-pointer">{t3}</div>;
    $[4] = t3;
    $[5] = tooltipId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== mounted || $[8] !== profile || $[9] !== tooltipId) {
    t5 = mounted && createPortal(<Tooltip id={tooltipId} clickable={true} place="right" opacity={1} border="1px solid #333" style={{
      backgroundColor: "#26272B",
      borderRadius: "8px",
      padding: "0",
      maxWidth: "360px",
      zIndex: 9999
    }}><UserCICTypeIconTooltip profile={profile} /></Tooltip>, document.body);
    $[7] = mounted;
    $[8] = profile;
    $[9] = tooltipId;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}